<script>
import { VDataTable } from 'vuetify/lib'
import { VSimpleCheckbox } from 'vuetify/lib'

export default {
  name: 'AcDataTableBulkRmv',
  inheritAttrs: false,
  components: { VDataTable, VSimpleCheckbox },
  model: { prop: 'value', event: 'input' },

  props: {
    value: { type: Array, default: () => [] },
    bulkMode: { type: Boolean, default: false },
    canSelect: { type: Function, default: () => true },
    selectColor: { type: String, default: 'red' },
    selectOffIcon: { type: String, default: 'mdi-checkbox-blank-outline' },
    selectOnIcon:  { type: String, default: 'mdi-checkbox-marked' },
    search: { type: String, default: '' },
  },

  render(h) {
    const VDT = this.$options.components.VDataTable
    const VSC = this.$options.components.VSimpleCheckbox

    const scopedSlots = { ...this.$scopedSlots }

    if (this.bulkMode && !scopedSlots['item.data-table-select']) {
      scopedSlots['item.data-table-select'] = ({ isSelected, select, item }) =>
        h(VSC, {
          props: {
            value: isSelected,
            disabled: !this.canSelect(item),
            color: this.selectColor,
            offIcon: this.selectOffIcon,
            onIcon: this.selectOnIcon
          },
          on: { input: select }
        })
    }

    return h(VDT, {
      style: { whiteSpace: 'nowrap' },
      scopedSlots,
      props: {
        ...this.$attrs,
        value: this.value,
        showSelect: this.bulkMode,
        search: this.search,
      },
      on: {
        ...this.$listeners,
        input: v => this.$emit('input', v)
      }
    })
  }
}
</script>
